import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Header } from './header';

const Container = styled.div`
  background: ${YELLOW} !important;

  .marquee-rtl {
    overflow: hidden;
  }
  .marquee-bg {
    background: ${YELLOW} !important;
    overflow: hidden;
  }
  .marquee-text {
    color: #010101;
    display: inline-block; /* modèle de boîte en ligne */
    padding-right: 2em; /* un peu d'espace pour la transition */
    padding-left: 100%; /* placement à droite du conteneur */
    white-space: nowrap; /* pas de passage à la ligne */
    animation: defilement-rtl 60s infinite linear;
  }
  @keyframes defilement-rtl {
    0% {
      transform: translate3d(0, 0, 0); /* position initiale à droite */
    }
    100% {
      transform: translate3d(-100%, 0, 0); /* position finale à gauche */
    }
  }
`;

export const Layout = ({
  children,
  other,
  hideYellowScrollInfo,
}: {
  children: ReactNode;
  other?: ReactNode;
  hideYellowScrollInfo?: boolean;
}) => {
  return (
    <div>
      <Header other={other} />
      {/* <>{other}</> */}
      {!hideYellowScrollInfo && (
        <Container>
          <div
            className='marquee-rtl'
            style={{ background: '#6d4c41', padding: '5px' }}
          >
            <div className='marquee-bg'>
              <div className='marquee-text'>
                <b>
                  ACTION REGIONALE : &nbsp;
                  <span style={{ color: ORANGE }}>42500 FCFA</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ACTION BANGE : &nbsp;
                  <span style={{ color: ORANGE }}>207110 FCFA</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ACTIONS SCG-Ré : &nbsp;
                  <span style={{ color: ORANGE }}>21000 FCFA</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ACTION SAFACAM : &nbsp;
                  <span style={{ color: ORANGE }}> 26000 FCFA</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOG 07 22/28 : &nbsp;
                  <span style={{ color: ORANGE }}>100,00 %</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  BDEAC 03 22/29 :&nbsp;
                  <span style={{ color: ORANGE }}> 100,00 %</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ECMR.06 22/29 : &nbsp;
                  <span style={{ color: ORANGE }}>96 %</span> (0,000 %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  BDEAC 02 21/28 :&nbsp;
                  <span style={{ color: ORANGE }}> 100 % </span> (0,000 %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ALIOS.02 21/25 : &nbsp;
                  <span style={{ color: ORANGE }}>100,00 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOG.06 21-26 :&nbsp;
                  <span style={{ color: ORANGE }}>99.50 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOCG.02-21/26 :&nbsp;
                  <span style={{ color: ORANGE }}> 95,00 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOTD01 22/27 :&nbsp;
                  <span style={{ color: ORANGE }}> 100,00 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOBDE01 20/27 :&nbsp;
                  <span style={{ color: ORANGE }}> 99,99 %</span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  EOG.05 19/24 :&nbsp;
                  <span style={{ color: ORANGE }}> 99,00 </span> (0,000 %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ECMR.05-18/23 :&nbsp;
                  <span style={{ color: ORANGE }}> 99,20 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ALIOS.01-18/23 :&nbsp;
                  <span style={{ color: ORANGE }}>100,00 % </span> (0,000
                  %)&nbsp;
                </b>
                &nbsp;--&nbsp;
                <b>
                  ACTION SEMC : &nbsp;
                  <span style={{ color: ORANGE }}> 47000 FCFA </span> (0,000
                  %)&nbsp;
                </b>
              </div>
            </div>
          </div>
        </Container>
      )}
      <div style={{ margin: 'auto' }}>{children}</div>
    </div>
  );
};
